<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span> Sync </span> /
      <span> Progress </span>
    </nav>
    <sync-steps :method="method"></sync-steps>

    <div class="container mt-5">
      <div class="my-5">
        <flow-progress :progress="progress"></flow-progress>
      </div>
      <h2 class="flow-heading">Sync in progress...</h2>
      <p v-if="contacts" class="sync-progress__stat">
        Syncing
        <template v-if="method === 'groups'"
          ><strong>{{ groups }}</strong> groups</template
        >
        <template v-else
          ><strong>{{ contacts }}</strong> contacts</template
        >
      </p>
      <p v-else class="sync-progress__stat sync-progress__stat--calculating">Calculating ...</p>
      <div>
        <a class="btn btn-lg btn-outline-primary mr-2 mb-2" href="/sync/select-method/">Return</a>
        <a class="btn btn-lg btn-primary mb-2" href="/sync/management">Open Sync Management</a>
      </div>
    </div>
  </div>
</template>

<script>
import SyncSteps from '../components/sync/SyncSteps';
import FlowProgress from '../components/shared/FlowProgress';
import {listenToPusherSyncEvents} from '../utility/notifications/listenToPusherSyncEvents';
import {syncGroups} from '../utility/api/sync/syncGroups.js';
import {syncAll} from '../utility/api/sync/syncAll.js';

export default {
  name: 'sync-progress-page',
  components: {SyncSteps, FlowProgress},
  data() {
    return {
      progress: 0,
      contacts: 0,
      groups: 0,
    };
  },
  props: {
    selectedGroupsIds: {
      type: String,
    },
    activeCrm: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      required: true,
    },
    syncing: {
      type: String,
    },
  },
  methods: {
    initializePusherSyncEvents() {
      listenToPusherSyncEvents(notification => {
        const {groups, contacts_received, contacts_processed} = notification.message.counts;
        this.groups = groups;
        this.contacts = contacts_received;
        this.progress =
          contacts_processed > this.progress
            ? Math.trunc((contacts_processed / contacts_received) * 100)
            : this.progress;

        if (notification.message.type === 'sync-finished') {
          this.progress = 100;
          setTimeout(() => {
            this.redirectToComplete();
          }, 500);
        }
        if (notification.message.type === 'sync-failed') {
          $.notify('Something went wrong! Sync Failed!', 'error');
        }
      });
    },
    redirectToComplete() {
      window.location.href = `/sync/complete?contacts=${this.contacts}&groups=${this.groups}&method=${this.method}`;
    },
  },
  mounted() {
    this.initializePusherSyncEvents();
    setTimeout(async () => {
      this.method === 'groups' ? await syncGroups(this.crmName, this.groupsIds) : await syncAll(this.crmName);
      if (this.isSyncing) {
        $.notify('Another sync is already in progress', 'error');
      }
    }, 1000);
  },
  computed: {
    crmName() {
      return JSON.parse(this.activeCrm).crm_name;
    },
    groupsIds() {
      return JSON.parse(this.selectedGroupsIds);
    },
    isSyncing() {
      const status = JSON.parse(this.syncing);
      return status.syncing;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';

.sync-progress {
  &__stat {
    color: $mine-shaft-color;
    margin: 20px auto 30px;
    &--calculating {
      animation: blink 2s linear infinite;
    }
  }
  &__img {
    margin: 30px auto 0;
  }
}
@keyframes blink {
  50% {
    opacity: 0.2;
  }
}
</style>
